// extracted by mini-css-extract-plugin
module.exports = {"prevLink":"styles-module--prev-link--2_7QI"};